<a
  class="w-full flex {{
    basePanelService.routeData.shortLeftNavigation
      ? xPartnerService.partner.MENU_SHORT_LOGO_POSITION
      : xPartnerService.partner.MENU_LOGO_POSITION
  }} items-center"
  [routerLink]="n.getPath('home')"
>
  <img
    [src]="xPartnerService.partner.SYSTEM_MENU_LOGO_PATH"
    [ngStyle]="{
      'max-height.px': xPartnerService.partner.MENU_LOGO_MAX_HEIGHT ?? 'unset'
    }"
    [alt]="xPartnerService.partner.SYSTEM_NAME"
    [title]="xPartnerService.partner.SYSTEM_NAME"
    *ngIf="!basePanelService?.routeData?.shortLeftNavigation"
  />
  <img
    [src]="xPartnerService.partner.SYSTEM_SHORT_MENU_LOGO_PATH"
    [ngStyle]="{
      'max-height.px': xPartnerService.partner.MENU_SHORT_LOGO_MAX_HEIGHT ?? 'unset'
    }"
    class="hidden md:block"
    [alt]="xPartnerService.partner.SYSTEM_NAME"
    [title]="xPartnerService.partner.SYSTEM_NAME"
    *ngIf="basePanelService?.routeData?.shortLeftNavigation"
  />
</a>
